import { render, staticRenderFns } from "./payBack.vue?vue&type=template&id=cb4fd29a&scoped=true"
import script from "./payBack.vue?vue&type=script&lang=js"
export * from "./payBack.vue?vue&type=script&lang=js"
import style0 from "./payBack.vue?vue&type=style&index=0&id=cb4fd29a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4fd29a",
  null
  
)

export default component.exports